import { useEffect } from 'react';
import { useGetIdentity, useGetOne, useRecordContext } from 'react-admin';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ShowWithNavigation } from '@sh4res/bo-common/components';
import { B2bSavingsFundRequestShow as CommonB2bSavingsFundRequestShow } from '@sh4res/bo-common/components/B2bSavingsFundRequests/B2bSavingsFundRequestShow';
import { B2bSavingsFundsRequestActions } from '@sh4res/bo-common/components/B2bSavingsFundRequests/B2bSavingsFundRequestsAction';
import { buildLink } from '@sh4res/bo-common/utils/build_link';
import { isBoExternal } from '@sh4res/bo-common/utils/env';

export const SavingsFundRequestShow = ({ id }: { id?: number }) => {
  const { data: identity } = useGetIdentity();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams<{ id?: string }>();
  const savingsFundRequestId = id ?? (params.id ? Number(params.id) : undefined);

  // The operation type comes from the embedding collective operation, or from the fund request
  // itself when the page is opened directly
  const contextRecord = useRecordContext<{ type?: string }>();
  const isDirectAccessPath =
    isBoExternal() && location.pathname.includes('/savings_funds_requests/');
  const { data: fetchedRecord } = useGetOne<{ id: number; type: string }>(
    'savings_funds_requests',
    { id: savingsFundRequestId ?? -1 },
    { enabled: isDirectAccessPath && savingsFundRequestId !== undefined },
  );
  const operationType = contextRecord?.type ?? fetchedRecord?.type;

  const isAdminLevel3or4 =
    identity?.roles.includes('admin_level_4') || identity?.roles.includes('admin_level_3');

  // https://sh4res.atlassian.net/browse/BRAV-9538
  // Redirect to collective_operations if accessed directly
  const collectiveOperationType =
    operationType === 'matching_contribution' || operationType === 'ccb_withdrawal'
      ? operationType
      : null;
  useEffect(() => {
    if (isDirectAccessPath && savingsFundRequestId !== undefined && collectiveOperationType) {
      const collectiveOperationId = `${collectiveOperationType}_${savingsFundRequestId}`;
      navigate(buildLink('collective_operations', 'show', collectiveOperationId), {
        replace: true,
      });
    }
  }, [isDirectAccessPath, savingsFundRequestId, collectiveOperationType, navigate]);

  return (
    <ShowWithNavigation
      id={id}
      actions={<></>}
      navigateTo={() => 'collective_operations'}
      logs={{
        resource: 'savings_funds_request',
      }}
      title={`resources.bo_external.collective_operations.choices.type.${collectiveOperationType ?? 'matching_contribution'}`}
      button={isAdminLevel3or4 ? <B2bSavingsFundsRequestActions /> : undefined}>
      <CommonB2bSavingsFundRequestShow />
    </ShowWithNavigation>
  );
};
